import React from 'react';
import { useAppStore } from '../../store/appStore';

export default function CameraCard({ camera, selected, onClick, groups }) {
  const { token } = useAppStore();
  const status = camera.status;
  const isOnline = status?.online;
  const group = groups?.find(g => g.id === camera.groupId);
  const snapshotUrl = `/api/snapshots/${camera.id}/live?token=${token}&t=${Date.now()}`;

  return (
    <div
      onClick={onClick}
      className="card"
      style={{
        cursor: 'pointer',
        border: selected ? '1px solid var(--accent-cyan)' : '1px solid var(--border-dim)',
        boxShadow: selected ? 'var(--shadow-glow-cyan)' : 'none',
        transition: 'all 0.2s',
        overflow: 'hidden',
      }}
      onMouseEnter={e => e.currentTarget.style.borderColor = selected ? 'var(--accent-cyan)' : 'var(--border-normal)'}
      onMouseLeave={e => e.currentTarget.style.borderColor = selected ? 'var(--accent-cyan)' : 'var(--border-dim)'}
    >
      {/* Video preview area */}
      <div style={{
        height: '140px',
        background: 'var(--bg-void)',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        {isOnline ? (
          <img
            src={snapshotUrl}
            alt="Camera preview"
            style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.85 }}
            onError={e => { e.target.style.display = 'none'; }}
          />
        ) : (
          <div style={{ color: 'var(--text-muted)', textAlign: 'center' }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.3">
              <circle cx="12" cy="12" r="9"/>
              <line x1="2" y1="2" x2="22" y2="22" strokeWidth="1.5"/>
            </svg>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', marginTop: '4px', opacity: 0.4 }}>NO SIGNAL</div>
          </div>
        )}

        {/* Overlay gradient */}
        <div style={{
          position: 'absolute', bottom: 0, left: 0, right: 0,
          height: '40px',
          background: 'linear-gradient(transparent, rgba(6,8,16,0.8))',
        }} />

        {/* Status badge */}
        <div style={{ position: 'absolute', top: '8px', left: '8px' }}>
          <span className={`badge ${isOnline ? 'badge-online' : status ? 'badge-offline' : 'badge-unknown'}`}>
            <span className={`status-dot ${isOnline ? 'online' : status ? 'offline' : 'unknown'}`} />
            {isOnline ? 'Live' : status ? 'Offline' : '?'}
          </span>
        </div>

        {/* Latency */}
        {isOnline && status?.latency && (
          <div style={{
            position: 'absolute', top: '8px', right: '8px',
            fontFamily: 'var(--font-mono)', fontSize: '10px',
            color: status.latency < 100 ? 'var(--accent-green)' : 'var(--accent-amber)',
          }}>
            {status.latency}ms
          </div>
        )}
      </div>

      {/* Info */}
      <div style={{ padding: '10px 12px' }}>
        <div style={{
          fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '14px',
          color: selected ? 'var(--accent-cyan)' : 'var(--text-primary)',
          letterSpacing: '0.04em', marginBottom: '3px',
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>{camera.name}</div>
        <div style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', color: 'var(--text-muted)' }}>
          {camera.ipAddress}:{camera.httpPort}
        </div>
        {camera.location && (
          <div style={{ fontFamily: 'var(--font-body)', fontSize: '11px', color: 'var(--text-muted)', marginTop: '2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {camera.location}
          </div>
        )}
        {group && (
          <div style={{ marginTop: '6px' }}>
            <span style={{
              fontSize: '10px', fontFamily: 'var(--font-mono)',
              padding: '2px 7px', borderRadius: '10px',
              background: `${group.color}22`, color: group.color,
              border: `1px solid ${group.color}44`,
            }}>{group.name}</span>
          </div>
        )}
      </div>
    </div>
  );
}
